// Router
import { useNavigate } from "react-router-dom";

// Libraries
import { useTranslation } from "react-i18next";

// Components
import { Stack, Typography, Button, Paper, Tooltip } from "@mui/material";

const MBSNotFound = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <Paper sx={{ width: "fit-content", p: 4 }}>
      <Stack spacing={2} alignItems="center">
        <Typography variant="h3">{t("mbsNotFound.title")}</Typography>
        <Typography variant="body1">{t("mbsNotFound.line1")}</Typography>
        <Typography variant="subtitle1">{t("mbsNotFound.line2")}</Typography>
        <Tooltip title={t("mbsNotFound.tooltip")} arrow>
          <Button
            variant="contained"
            size="large"
            onClick={() => navigate("/mbs")}
          >
            {t("mbsNotFound.button")}
          </Button>
        </Tooltip>
      </Stack>
    </Paper>
  );
};

export default MBSNotFound;
